import emailjs from 'emailjs-com';

/**
 * Sends a booking confirmation email using EmailJS.
 * @param {Object} formData - Contains booking details like name, phone, date, table, startTime, and endTime.
 * @param {string} type - Type of the email, e.g., 'NEW BOOKING' or 'UPDATED BOOKING'.
 */
const sendEmail = (formData, type = 'NEW BOOKING') => {
  const templateParams = {
    name: formData.name,
    phone: formData.phone,
    date: formData.date,
    table: formData.table,
    slot: `${formData.startTime} - ${formData.endTime}`,
    email: 'snookerhut25@gmail.com',
    message: type, // Add this to your EmailJS template if you want to display it
  };

  return emailjs
    .send('service_qauhmi9', 'template_dw54axh', templateParams, 'EHiFdFwyqoWZHBwpY')
    .then((response) => {
      console.log(`${type} email sent successfully!`, response.status, response.text);
      return response;
    })
    .catch((err) => {
      console.error(`Failed to send ${type} email:`, err);
      throw err;
    });
};

export default sendEmail;
